import React from 'react'
import './KeyFeatureComponent.css'
import Common_Enquiry_Form from '../../Common_Component/Common_Enquiry_Form/Common_Enquiry_Form'


const KeyFeatureComponent = () => {

    const data = [
        {
          title: "Instant Loan",
          descn:
            "Get access to funds in just a few clicks with our hassle-free instant loan process. Whether it's for emergencies, business needs, or personal goals, we ensure quick approvals and immediate disbursal.",
          img: "/assets/Image/Home/feature/img1.png",
        },
        {
          title: "Over 11.5 lac Happy Customers",
          descn:
            "Join a growing family of satisfied customers who trust us for reliable financial solutions. Our commitment to customer satisfaction has made us a preferred choice across the nation.",
          img: "/assets/Image/Home/feature/img2.png",
        },
        {
          title: "Dedicated Support Team",
          descn:
            "Our professional support team is available round-the-clock to assist you. From initial queries to after-loan services, we’re here to provide personalized guidance at every step.",
          img: "/assets/Image/Home/feature/img3.png",
        },
      ];
    

    return (
        <section className='KeyFeatureComponent'>

            <div className='container'>
                <div className='content_holder'>
                    <div className='row'>

                        <div className='col-lg-7'>
                            <div className='key_feature_main_div'>
                                <p className='section_heading'>Key Features</p>
                                <p className='sub_heading'>Special features only with our company</p>

                                <div className='feature_outer_div'>

                                    {data?.map((item) => {
                                        return (
                                            <div className='feature_inner'>
                                                <div className='img_div'>
                                                    <img src={item?.img} className='img' />
                                                </div>

                                                <div className='text_holder'>
                                                    <p className='title'>{item?.title}</p>
                                                    <p className='descn'>{item?.descn}</p>
                                                </div>
                                            </div>
                                        )
                                    })}

                                </div>

                            </div>
                        </div>

                        <div className='col-lg-5 custom_col'>
                            <div className='form_main_div'>
                                <Common_Enquiry_Form />
                            </div>
                        </div>

                    </div>
                </div>
            </div>


        </section>
    )
}

export default KeyFeatureComponent
